import {
  createClient,
  SaveOperation,
  SearchOperation,
  postRequestFactory,
  searchRequestFactory,
  IdPathParameters
} from '@infuse/api/common';
import { AssignModel, OwnerResponse } from './owner-types';

const client = createClient('/rest/operator-api/firmware');

export const firmwareAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-firmware',
  UNASSIGN: 'cpms.unassign-firmware',
  SEARCH_OWNERS: 'cpms.search-firmware-owners'
};

export type AssignFirmwareRequest = AssignModel;
export type UnassignFirmwareRequest = AssignModel;

export const assignFirmware: SaveOperation<AssignFirmwareRequest, void, string> = postRequestFactory<
  AssignFirmwareRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: firmwareAccessManagementPermissions.ASSIGN
});

export const unassignFirmware: SaveOperation<UnassignFirmwareRequest, void, string> = postRequestFactory<
  UnassignFirmwareRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: firmwareAccessManagementPermissions.UNASSIGN
});

export const getFirmwareOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: firmwareAccessManagementPermissions.SEARCH_OWNERS
});
